import React from 'react';
import { FiberManualRecord, CheckCircle, ErrorOutline } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '36px',
        width: '28px',
    },
    pulseDot: {
        color: theme.palette.warning.main,
        animation: '$pulse 1.5s ease-in-out infinite',
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
    },
    checkIcon: {
        color: theme.palette.success.main,
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
    },
    errorIcon: {
        color: theme.palette.error.main,
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
        animation: '$shake 0.5s ease-in-out infinite',
    },
    '@keyframes pulse': {
        '0%': {
            opacity: 0.6,
            transform: 'scale(0.95)',
        },
        '50%': {
            opacity: 1,
            transform: 'scale(1.1)',
        },
        '100%': {
            opacity: 0.6,
            transform: 'scale(0.95)',
        },
    },
    '@keyframes shake': {
        '0%': { transform: 'translateX(0)' },
        '25%': { transform: 'translateX(-2px)' },
        '50%': { transform: 'translateX(2px)' },
        '75%': { transform: 'translateX(-2px)' },
        '100%': { transform: 'translateX(0)' },
    },
}));

const UnsavedChangesDot = ({ hasUnsavedChanges, saving, failure }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    let tooltip = '';
    if (failure) {
        tooltip = t('general.failedToSave');
    } else if (!hasUnsavedChanges && !saving) {
        tooltip = t('general.allChangesSaved');
    } else {
        tooltip = t('general.hasUnsavedChangesSaving');
    }

    return (
        <Tooltip title={tooltip}>
            <span className={classes.container}>
                {failure ? (
                    <ErrorOutline className={classes.errorIcon} />
                ) : hasUnsavedChanges || saving ? (
                    <FiberManualRecord className={classes.pulseDot} />
                ) : (
                    <CheckCircle className={classes.checkIcon} />
                )}
            </span>
        </Tooltip>
    );
};

export default UnsavedChangesDot;
